import { colors } from "./colors"
import { breakpoints} from "./breakpoints"

export const theme = {
  colors,
  breakpoints,
  primaryColor: colors.orange,
  font: {
    thin: 300,
    regular: 400,
    bold: 700,
  },

  
}
